"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.PurchaseProvider = exports.PurchaseState = void 0;
var PurchaseState;
(function (PurchaseState) {
    PurchaseState["PENDING"] = "pending";
    PurchaseState["FINALIZED"] = "finalized";
    PurchaseState["FAILED"] = "failed";
})(PurchaseState = exports.PurchaseState || (exports.PurchaseState = {}));
var PurchaseProvider;
(function (PurchaseProvider) {
    PurchaseProvider["STRIPE"] = "stripe";
    PurchaseProvider["GOOGLE"] = "google";
    PurchaseProvider["APPLE"] = "apple";
    PurchaseProvider["KVIX"] = "kvix";
    PurchaseProvider["SWISH"] = "swish";
})(PurchaseProvider = exports.PurchaseProvider || (exports.PurchaseProvider = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["DEPOSIT"] = "deposit";
    TransactionType["WITHDRAWAL"] = "withdrawal";
    TransactionType["PURCHASE"] = "purchase";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
//# sourceMappingURL=Account.js.map